/* eslint-disable flowtype/require-valid-file-annotation */

import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import DaySpacer from "./DaySpacer";
import HoursDay from "./HoursDay";
import C from "./../../Constants";
import moment from "moment";

const styles = theme => ({
    hoursNavigationContainer: {
        height: "100%",
        width: "100%",
        flex: "0 1 auto",
        zIndex: 2,
        position: "sticky",
        left: 0
    },
    hoursNavigationHeader: {
        position: "sticky",
        top: 0,
    },
    day: {},
    hour: {},
    raster: {},
    hourRasterDense: {},
    hourRasterWide: {},
    dayRasterDense: {},
    dayRasterWide: {},
    daysNotContinuousSpacer: {
        backgroundColor: "#EEE",
        borderRight: "1px solid #999999",
        boxSizing: "border-box",
    }
});

class HoursBody extends React.Component {

    render() {
        const {classes} = this.props;
        let previousDate = null;
        return this.props.hours.map((day, index) => {
            const date = moment(day[0], C.inputDatePatternMoment);
            const hoursOfDay = day[1];
            const renderedDay =
                <HoursDay key={"d" + day[0]} date={date} hoursOfDay={hoursOfDay}
                          container={this} hourTypes={this.props.hourTypes} dense={this.props.dense}
                          classes={{
                              raster: classes.raster, day: classes.day, hour: classes.hour,
                              dayRasterDense: classes.dayRasterDense, dayRasterWide: classes.dayRasterWide,
                              hourRasterDense: classes.hourRasterDense, hourRasterWide: classes.hourRasterWide
                          }}/>;
            //is previous date in array the date yesterday??
            const isContinuesDate = previousDate == null || date.clone().subtract(1, 'day').isSame(previousDate);
            previousDate = date;
            if (isContinuesDate) {
                return renderedDay;
            } else {
                return <React.Fragment>
                    <DaySpacer classes={{raster: classes.raster}} key={"s" + day[0]}>{this.spacerHeight()}</DaySpacer>
                    {renderedDay}
                </React.Fragment>
            }
        });
    }

    hourSelected = (date, hour) => this.props.hoursPanel.hourSelected(date, hour);
    hourHovered = (date, hour) => this.props.hoursPanel.hourHovered(date, hour);

    spacerHeight() {
        const {classes} = this.props;
        const day = [];
        for (let i = 0; i < 24; i++)
            day[i] = <div key={i} className={classes.daysNotContinuousSpacer + " " + (this.props.dense
                ? classes.hourRasterDense : classes.hourRasterWide)}/>;
        return day;
    }
}

HoursBody.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles, {name: "hourPanel"})(HoursBody);